// src/components/LogoTrsAnimado.jsx
// Logo TRS por capas, animado con una línea de tiempo de GSAP: las letras entran inclinadas una tras otra, la órbita se dibuja,
// la esfera aparece con rebote elástico y el texto sube palabra por palabra.
import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { LOGO_TRS as P } from "./logoTrsPaths";

export default function LogoTrsAnimado({ onFin }) {
  const raiz = useRef(null);

  useLayoutEffect(() => {
    const reducir = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reducir) return undefined; // se queda el logo completo y quieto

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ onComplete: () => onFin?.() });
      tl.from(".lt", { y: 60, opacity: 0, rotation: -8, transformOrigin: "50% 100%", stagger: 0.12, duration: 0.7, ease: "back.out(1.7)" })
        .fromTo(".guia", { attr: { "stroke-dasharray": 1, "stroke-dashoffset": 1 } }, { attr: { "stroke-dashoffset": 0 }, duration: 1, ease: "power2.inOut" }, "-=.3")
        .from(".bola", { scale: 0, transformOrigin: "50% 50%", duration: 0.9, ease: "elastic.out(1,.4)" }, "-=.35")
        .from(".pal", { y: 18, opacity: 0, stagger: 0.08, duration: 0.5, ease: "power3.out" }, "-=.5");
    }, raiz);
    return () => ctx.revert();
  }, [onFin]);

  return (
    <svg ref={raiz} viewBox="0 0 591 335" role="img" aria-label="Total Radio Systems" style={{ width: "min(420px, 80vw)", height: "auto", overflow: "visible" }}>
      <defs>
        <linearGradient id="trs-go" gradientUnits="userSpaceOnUse" x1="237" y1="0" x2="572" y2="0">
          <stop offset="0" stopColor="#d2f8ff" />
          <stop offset=".22" stopColor="#00e6ff" />
          <stop offset=".68" stopColor="#00b9ff" />
          <stop offset="1" stopColor="#00e2ff" />
        </linearGradient>
        <radialGradient id="trs-ge" cx=".36" cy=".3" r=".75">
          <stop offset="0" stopColor="#ff9a62" />
          <stop offset=".45" stopColor="#ff4d14" />
          <stop offset="1" stopColor="#e01200" />
        </radialGradient>
        <mask id="trs-m" maskUnits="userSpaceOnUse" x="0" y="0" width="591" height="335">
          <path className="guia" d={P.cl} pathLength="1" fill="none" stroke="#fff" strokeWidth="58" strokeLinecap="round" />
        </mask>
      </defs>
      <g fill="#005d64">
        <path className="lt" d={P.T} />
        <path className="lt" d={P.R} />
        <path className="lt" d={P.S} />
      </g>
      <path fill="url(#trs-go)" d={P.orbita} mask="url(#trs-m)" />
      <path className="bola" fill="url(#trs-ge)" d={P.esfera} />
      <g fill="#ff6022">
        {Object.entries(P.words).map(([k, d]) => <path key={k} className="pal" d={d} />)}
      </g>
    </svg>
  );
}
